import React from 'react';
import { Monitor, Tablet, Smartphone, Maximize2, Minimize2, RotateCcw, Eye } from 'lucide-react';

export default function CMSPreviewToolbar({
  viewport = 'desktop',
  onViewportChange,
  isExpanded = false,
  onToggleExpand,
  onResetView,
  section,
  status = 'draft',
}) {
  const isLive = status === 'published' || status === 'active';

  return (
    <div className="bg-slate-800 text-slate-200 px-4 py-2 border-b border-slate-700 flex flex-wrap items-center justify-between gap-3 text-xs flex-shrink-0">
      {/* Left: Device Viewports */}
      <div className="flex items-center gap-1.5">
        <span className="text-slate-400 font-semibold mr-1 flex items-center gap-1 text-[11px]">
          <Eye className="w-3.5 h-3.5 text-blue-400" /> Preview:
        </span>
        <div className="flex bg-slate-900 rounded-lg p-0.5 border border-slate-700">
          <button
            type="button"
            title="Desktop View (100%)"
            onClick={() => onViewportChange('desktop')}
            className={`px-2.5 py-1 rounded flex items-center gap-1 text-[11px] font-medium transition ${
              viewport === 'desktop' ? 'bg-[#2B3380] text-white shadow-sm' : 'text-slate-400 hover:text-white'
            }`}
          >
            <Monitor className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Desktop</span>
          </button>
          <button
            type="button"
            title="Tablet View (768px)"
            onClick={() => onViewportChange('tablet')}
            className={`px-2.5 py-1 rounded flex items-center gap-1 text-[11px] font-medium transition ${
              viewport === 'tablet' ? 'bg-[#2B3380] text-white shadow-sm' : 'text-slate-400 hover:text-white'
            }`}
          >
            <Tablet className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Tablet</span>
          </button>
          <button
            type="button"
            title="Mobile View (375px)"
            onClick={() => onViewportChange('mobile')}
            className={`px-2.5 py-1 rounded flex items-center gap-1 text-[11px] font-medium transition ${
              viewport === 'mobile' ? 'bg-[#2B3380] text-white shadow-sm' : 'text-slate-400 hover:text-white'
            }`}
          >
            <Smartphone className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Mobile</span>
          </button>
        </div>
      </div>

      {/* Right: State & Expand Actions */}
      <div className="flex items-center gap-2">
        <span
          className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${
            isLive ? 'bg-emerald-950 text-emerald-300 border border-emerald-700' : 'bg-amber-950 text-amber-300 border border-amber-700'
          }`}
        >
          {isLive ? '● Live' : '◐ Draft'}
        </span>

        {onResetView && (
          <button
            type="button"
            title="Reset View"
            onClick={onResetView}
            className="p-1 rounded text-slate-400 hover:text-white hover:bg-slate-700 transition"
          >
            <RotateCcw className="w-3.5 h-3.5" />
          </button>
        )}

        {onToggleExpand && (
          <button
            type="button"
            title={isExpanded ? 'Restore Layout' : 'Expand Preview'}
            onClick={onToggleExpand}
            className="p-1 rounded text-slate-400 hover:text-white hover:bg-slate-700 transition"
          >
            {isExpanded ? <Minimize2 className="w-3.5 h-3.5" /> : <Maximize2 className="w-3.5 h-3.5" />}
          </button>
        )}
      </div>
    </div>
  );
}
